<template>
    <q-dialog ref="dialog" @hide="onDialogHide" persistent>
        <q-card class="q-dialog-plugin " style="width: 30vw; max-width: 90vw;">
            <q-toolbar class="bg-primary text-white">
                <q-toolbar-title v-text="(actionTitle + ' ' + screenTitle).trim()"></q-toolbar-title>
                <q-btn flat round dense icon="close" v-close-popup></q-btn>
            </q-toolbar>

            <q-form ref="modelForm">
                <q-card-section>
                    <div class="flex column wrap">
                        <div class="row q-col-gutter-lg">
                            <div class="col-12" >
                            <q-input v-model="model.FileName" type="text" 
                                     label="File" 
                                      
                                      
                                      readonly
                                     :rules="[]"
                                     :error="fieldHasError('FileName')"
                                     :error-message="fieldErrorMessage('FileName')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-12" >
                            <q-input v-model="model.EndPointName" type="text" 
                                     label="End Point" 
                                      
                                      
                                      readonly
                                     :rules="[]"
                                     :error="fieldHasError('EndPointName')"
                                     :error-message="fieldErrorMessage('EndPointName')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-12" >
                            <q-input v-model="model.CanonicalId" type="text" 
                                     label="Canonical ids" 
                                      
                                      
                                      readonly
                                     :rules="[]"
                                     :error="fieldHasError('CanonicalId')"
                                     :error-message="fieldErrorMessage('CanonicalId')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-4" >
                            <q-input v-model="model.Status" type="text" 
                                     label="Status" 
                                      
                                      
                                      readonly
                                     :rules="[]"
                                     :error="fieldHasError('Status')"
                                     :error-message="fieldErrorMessage('Status')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-4" >
                            <q-input v-model="model.OutCount" type="number" 
                                     label="Out Cnt" 
                                      
                                      
                                      readonly
                                     :rules="[]"
                                     :error="fieldHasError('OutCount')"
                                     :error-message="fieldErrorMessage('OutCount')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-4" >
                            <q-input v-model="model.Retries" type="number" 
                                     label="Retries" 
                                      
                                      
                                      readonly
                                     :rules="[]"
                                     :error="fieldHasError('Retries')"
                                     :error-message="fieldErrorMessage('Retries')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-12" v-show="model.Status==='Failure'">
                            <q-input v-model="model.Error" type="textarea" rows="8" 
                                     label="Error" 
                                      
                                      
                                      readonly
                                     :rules="[]"
                                     :error="fieldHasError('Error')"
                                     :error-message="fieldErrorMessage('Error')"
                                     
                                     dense>
                                
                                
                            </q-input>
                        </div>

                        </div>
                    </div>
                </q-card-section>
            </q-form>

            <q-toolbar>
                <div class="q-gutter-xs">
                    
                </div>

                <q-space></q-space>

                <div class="q-gutter-xs" v-if="editMode === true">
                    
                    <q-btn color="primary" :label="actionLabel" @click="onOkClick" :disable="actionLocked"></q-btn>
                    <q-btn color="white" text-color="black" label="Cancel" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
                <div class="q-gutter-xs" v-if="editMode === false">
                    
                    <q-btn color="white" text-color="black" label="Close" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
            </q-toolbar>

            <q-inner-loading :showing="loading">
                <q-spinner-gears size="50px" color="primary"></q-spinner-gears>
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>

<style>
    
</style>

<script>
    export { default } from './processedfileviewmodel-dialog-screen.js'
</script>